import { Link, useMatch, useResolvedPath } from "react-router-dom"
import { BsFillPersonFill, BsCollectionFill, BsAward, BsPin, BsFileEarmarkPdfFill } from "react-icons/bs"
import { useEffect, useState } from "react";

export default function Navbar()
{
    const [isNavOpen, setNavOpen] = useState(false);

    return (
        <nav className = "nav">
            <div className="nav-title-container">
                <Link to="/" className = "nav-site-title-container" onClick={() => setNavOpen(false)}>
                    <div className="nav-title-text-container">
                        <div className = "nav-title initial">Seow</div>
                        <div className = "nav-title name">Sin Kiat</div>
                    </div>
                </Link>
                <div className={`toggle-button ${isNavOpen ? 'open' : ''}`} onClick={() => setNavOpen(!isNavOpen)}>
                    <span className="bar"></span>
                    <span className="bar"></span>
                    <span className="bar"></span>
                </div>
            </div>
            <div className = {`nav-expanded ${isNavOpen ? "" : "close" }`}>
                <div className = {`nav-content-container`}>
                    <CustomLink to="/about" onClick={() => setNavOpen(false)}>
                        <div className="navLinks">
                            <BsFillPersonFill/>
                            <span>About</span>
                        </div>
                    </CustomLink>
                    <CustomLink to="/skills" onClick={() => setNavOpen(false)}>
                        <div className="navLinks">
                            <BsAward/>
                            <span>Skills</span>
                        </div>
                    </CustomLink>
                    <CustomLink to="/projects" onClick={() => setNavOpen(false)}>
                        <div className="navLinks">
                            <BsCollectionFill/>
                            <span>Project</span>
                        </div>
                    </CustomLink>
                </div>
            </div>
        </nav>
    );
}

function CustomLink({to, children, ...props})
{
    //const path = window.location.pathname;
    const resolvedPath = useResolvedPath(to)
    const isActive = useMatch( {path: resolvedPath.pathname, end: true})
    return (
        <li className={`navlinks-container ${isActive ? "active" : ""}`}>
            <Link className={isActive ? "active" : ""} to = {to} {...props}>{children}</Link>
        </li>
    )
}